import { Lot, ID } from 'types';
import { ApiUrl, Call, ParseGeneralResponse } from '@api/ApiUtils';

interface LoadLotResponse {
  errors: string[];
  lot: Lot;
  success: boolean;
}

interface LoadLotParams {
  eventId: ID;
  lotId: ID;
}

export const loadLot = async ({ eventId, lotId }: LoadLotParams): Promise<LoadLotResponse> => {
  const url = ApiUrl(`/events/${eventId}/lots/${lotId}`);

  return Call(
    'get',
    url,
    {},
    ParseGeneralResponse,
    {
      responseDataKeys:
      {
        lot: 'lot',
      },
    },
  );
};
